<template>
  <v-container max-width="900px" class="pt-4">
    <div class="text-center mb-6">
      <h1 class="mb-0"><span>💬</span>{{ $t('rollOffWizard.notes.title') }}</h1>
      <p class="mb-0">{{ $t('rollOffWizard.notes.subtitle') }}</p>
    </div>
    <v-row class="mt-2" justify="center">
      <v-col cols="12" md="7" lg="5">
        <div class="mb-6">
          <div v-if="wizardStore.projectType != 'short-term'" class="mb-4">
            <div class="d-flex align-start justify-space-between font-weight-bold mb-1">
              <label>{{ $t('rollOffWizard.notes.placementLabel') }}</label>
              <span class="secondary--text font-weight-regular" style="font-size:0.98rem;">{{ $t('optional') }}</span>
            </div>
            <v-textarea
              class="rounded-lg"
              v-model="placement"
              :placeholder="$t('rollOffWizard.notes.placementPlaceholder')"
              outlined
              auto-grow
            />
          </div>
          <div v-if="wizardStore.projectType != 'short-term'">
            <div class="d-flex align-start justify-space-between font-weight-bold mb-1">
              <label>{{ $t('rollOffWizard.notes.accessibilityLabel') }}</label>
              <span class="secondary--text font-weight-regular" style="font-size:0.98rem;">{{ $t('optional') }}</span>
            </div>
            <v-textarea
              class="rounded-lg"
              v-model="accessibility"
              :placeholder="$t('rollOffWizard.notes.accessibilityPlaceholder')"
              outlined
              auto-grow
            />
          </div>
          <div>
            <div class="d-flex align-start justify-space-between font-weight-bold mb-1">
              <label>{{ $t('rollOffWizard.notes.spaceLabel') }}</label>
              <span class="secondary--text font-weight-regular" style="font-size:0.98rem;">{{ $t('optional') }}</span>
            </div>
            <v-textarea
              class="rounded-lg"
              v-model="space"
              :placeholder="$t('rollOffWizard.notes.spacePlaceholder')"
              outlined
              auto-grow
            />
          </div>
          <div>
            <div class="d-flex align-start justify-space-between font-weight-bold mb-1">
              <label>{{ $t('rollOffWizard.notes.detailsLabel') }}</label>
              <span class="secondary--text font-weight-regular" style="font-size:0.98rem;">{{ $t('optional') }}</span>
            </div>
            <v-textarea
              class="rounded-lg"
              v-model="details"
              :placeholder="$t('rollOffWizard.notes.detailsPlaceholder')"
              outlined
              auto-grow
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from 'vue'
import { useRollOffWizardStore } from '@/store/rollOffWizard'

const wizardStore = useRollOffWizardStore()

const placement = computed({
  get: () => wizardStore.placement,
  set: val => wizardStore.setPlacement(val)
})
const accessibility = computed({
  get: () => wizardStore.accessibility,
  set: val => wizardStore.setAccessibility(val)
})
const space = computed({
  get: () => wizardStore.space,
  set: val => wizardStore.setSpace(val)
})
const details = computed({
  get: () => wizardStore.details,
  set: val => wizardStore.setDetails(val)
})
</script>